import React from "react";

import CappedPage from "../common/CappedPage";
import Breadcrumbs from "../utils/Breadcrumbs";

import type { JSX, ReactNode } from "react";

import type { BreadcrumbItem } from "../utils/Breadcrumbs";

interface AnalyticsPageProps {
  heading: ReactNode;
  actions?: ReactNode;
  breadcrumbList?: BreadcrumbItem[];
  children: ReactNode;
}

function AnalyticsPage({
  heading,
  actions,
  breadcrumbList,
  children,
}: AnalyticsPageProps): JSX.Element {
  return (
    <CappedPage contentClassName="@container flex flex-col gap-6 pt-[30px] pb-15">
      {breadcrumbList ? <Breadcrumbs items={breadcrumbList} /> : null}
      <div className="flex flex-wrap items-center justify-between gap-4">
        {heading}
        {actions}
      </div>
      {children}
    </CappedPage>
  );
}

export default AnalyticsPage;
